import get from 'lodash/get';
import { INIT_ROOT, START_OVER, UPDATE_CONFIG_SUCCESS } from '../actionTypes';

export default function wasTrimOptionToggled(state, action) {
  const { type, payload } = action;
  switch (type) {
    case INIT_ROOT:
    case UPDATE_CONFIG_SUCCESS:
      return get(payload, 'wasTrimOptionToggled', false);
    case START_OVER:
      return false;
    default:
      return state || false;
  }
}
